import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Industry {
  name: string;
  icon: string;
}

@Component({
  selector: 'app-recruiter-hiring-solutions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recruiter-hiring-solutions.component.html',
  styleUrls: ['./recruiter-hiring-solutions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterHiringSolutionsComponent {
  readonly industries: Industry[] = [
    { name: 'IT & Software', icon: 'code' },
    { name: 'Healthcare', icon: 'heart' },
    { name: 'Manufacturing', icon: 'factory' },
    { name: 'Banking & Finance', icon: 'bank' },
    { name: 'Education', icon: 'education' },
    { name: 'Retail', icon: 'bag' },
    { name: 'Logistics', icon: 'truck' },
    { name: 'Hospitality', icon: 'cutlery' },
    { name: 'Consulting', icon: 'briefcase' },
    { name: 'Government', icon: 'building' }
  ];
}
